// ConfirmToast.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";
import "./Confirm.css";
import ButtonComponent from "../../buttons/ButtonComponent";

/**
 * `п. 1` резерва (пара к п. 19): подтверждение вводом.
 *
 * Для перевыпуска секрета мало «да»: действие необратимо для изделия, и человек
 * обязан **назвать изделие** — ввести его идентификатор. Пока введённое не
 * совпало, кнопка подтверждения недоступна: «да» вслепую здесь не проходит.
 */
export interface ConfirmInput {
  label: string;
  placeholder?: string;
  /** Что нужно ввести, чтобы подтверждение стало доступно. */
  expected: string;
}

interface ConfirmToastProps {
  message: string;
  /** Введённое значение (если подтверждение вводом) — уходит в действие. */
  onConfirm: (typed?: string) => void | Promise<void>;
  onCancel?: () => void;
  type?: string;
  cancelType?: string;
  title?: string;
  cancelTitle?: string;
  toastId?: string | number;
  closeOnConfirm?: boolean;
  confirmInput?: ConfirmInput;
}

const ConfirmToast = ({
  message,
  onConfirm,
  onCancel,
  type,
  cancelType,
  title,
  cancelTitle = "отмена",
  toastId,
  closeOnConfirm = true,
  confirmInput,
}: ConfirmToastProps) => {
  const [typed, setTyped] = useState<string>("");

  const matches = !confirmInput || typed.trim() === confirmInput.expected;

  const dismiss = () => {
    if (toastId !== undefined) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  };

  const handleConfirm = async () => {
    if (!matches) return;

    await onConfirm(confirmInput ? typed.trim() : undefined);
    if (!closeOnConfirm) return;
    dismiss();
  };

  const handleCancel = () => {
    onCancel?.();
    dismiss();
  };

  return (
    <div className="toast-container">
      <p className="toast-message">{message}</p>

      {confirmInput && (
        <label className="toast-input">
          <span className="toast-input-label">{confirmInput.label}</span>
          <input
            className="toast-input-field"
            value={typed}
            placeholder={confirmInput.placeholder}
            onChange={(e) => setTyped(e.target.value)}
            autoCapitalize="none"
            autoComplete="off"
          />
        </label>
      )}

      <div className="toast-button-group">
        <ButtonComponent
          onClick={handleConfirm}
          title={title}
          type={type}
          disabled={confirmInput ? !matches : undefined}
        />
        {onCancel && (
          <ButtonComponent
            onClick={handleCancel}
            title={cancelTitle}
            type={cancelType}
          />
        )}
      </div>
    </div>
  );
};

export default ConfirmToast;
